<app-topbar [isMobileBreakpoint]="isMobileBreakpoint"></app-topbar>
<app-navbar [isMobileBreakpoint]="isMobileBreakpoint"></app-navbar>
<div class="container-fluid bkg-color px-20">
  <router-outlet></router-outlet>
</div>
<app-privacy-notice></app-privacy-notice>
<ey-toast></ey-toast>
